import React from 'react';
import clsx from 'clsx';
import {IconChecked} from '../Icon';
import styles from './Checkbox.module.css';
import {Base} from '../../Internal';

export interface Props
  extends Omit<React.ComponentPropsWithoutRef<'input'>, 'className'> {
  isError?: boolean;
}

export const Checkbox = React.forwardRef(
  (props: Props, ref?: React.Ref<HTMLInputElement>) => {
    const {isError, ...restProps} = props;

    return (
      <div className={styles.root}>
        <Base
          as="input"
          forwardRef={ref}
          type="checkbox"
          className={clsx(styles.input, {[styles.error]: isError})}
          aria-invalid={isError}
          {...restProps}
        />
        <div className={styles.fakeCheckbox}>
          <IconChecked size={16} />
        </div>
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
